import { render, staticRenderFns } from "./Politica.vue?vue&type=template&id=3d9b24d1&"
import script from "./Politica.vue?vue&type=script&lang=js&"
export * from "./Politica.vue?vue&type=script&lang=js&"
import style0 from "./Politica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports